import logo from "./logo.svg";
import "./App.css";

function App() {
  return <div className='App'>AI IS UNDER CONSTRUCTION</div>;
}

export default App;
